import React from 'react';

const BLKLogo = ({ variant = 'default' }) => {
  if (variant === 'image-only') {
    return (
      <img
        src="/logos/blkpixel-logo.png"
        alt="BLKPixel Technologies"
        className="h-14 w-auto object-contain"
        style={{ mixBlendMode: 'lighten' }}
      />
    );
  }

  return (
    <div className="flex items-center gap-2.5">
      <img
        src="/logos/blkpixel-logo.png"
        alt="BLKPixel Technologies"
        className="h-11 w-11 object-contain"
        style={{ mixBlendMode: 'lighten' }}
      />
      <div className="leading-none">
        <div className="text-white font-black tracking-tight text-[17px]">
          BLK<span className="bg-gradient-to-r from-[#c084fc] to-[#a855f7] bg-clip-text text-transparent">PIXEL</span>
        </div>
        <div className="text-[8.5px] tracking-[0.25em] text-gray-400 mt-0.5">
          TECHNOLOGIES
        </div>
      </div>
    </div>
  );
};

export default BLKLogo;
